import { PublishedArtifactGroupId } from '@deltasierra/ids';
import { Auditable, HasId, ParanoidAuditable } from '../common';
import { PublishedArtifact } from './PublishedArtifact';

export { PublishedArtifactGroupId } from '@deltasierra/ids';

export interface PublishedArtifactGroup extends HasId<PublishedArtifactGroupId>, Auditable, ParanoidAuditable {
    publishedArtifacts?: PublishedArtifact[];
}
